<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />


<div *ngIf="isLoading" class="global-loader">
  <div class="loader-content">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
</div>
<div *ngIf="data" class="benefits-container">
  <div *ngIf="!global.isMobile()"
    style="font-size:11px;line-height:16.5px;font-weight:400;font-family:Poppins;color:#989AA3 !important;margin-bottom:30px; padding-left:2%;"
    class="breadcrumbfont">
    <sd-breadcrumb [data]="{'breadcrumb':[{'name':'Pro Perks',link:'/pro-perks'},{'name':this.slug}], 'version':2}">
    </sd-breadcrumb>
    <sd-content-banner class='block m-t-20'></sd-content-banner>
  </div>

  <div *ngIf="global.isMobile()"
    style="font-size:11px;line-height:16.5px;font-weight:400;font-family:Poppins;color:#989AA3 !important;"
    class="breadcrumbfont">
    <sd-content-banner class='block m-t-20' style="margin:20px;"></sd-content-banner>
  </div>
  <div class="hero-section">
    <div class="hero-content ps col-md-6 col-12">
      <!-- <span class="exclusive-badge">Songdew Pro Exclusive</span>
        -->
      <img src="../../../assets/image/masterclass/Pro Icon.svg" class="img-fluid" alt="pro icon">
      <h1>
        <span class="highlight">Pros</span> with Benefits
      </h1>
      <p>
        As a valued Pro subscriber, you have access to premium resources, exclusive discounts, and
        specialized content to accelerate your music journey.
      </p>
    </div>
    <div class="col-md-6 col-12 d-flex justify-content-center align-items-center">
      <img src="../../../assets/image/masterclass/artistImage.png" class="img-fluid" alt="Artist Image">
    </div>
  </div>

  <div class="new-section">
    <div class="row">
      <div class="col-md-6" *ngFor="let data of data.weeklyOnboardingSession; index as ind">
        <h2>{{data.title}}</h2>
        <div class="content">
          <p>{{data.description}}<br>{{data.descriptionAdditional}}</p>
          <p>
            <i><img src="../../../assets/image/masterclass/calendar.png" alt="calendarImage"></i> {{data.date}}
          </p>
          <p>
            <i><img src="../../../assets/image/masterclass/clock.png" alt="clockImage"></i> {{data.timeAndDuration}}
          </p>
          <a *ngIf="user.isProMember == 1" href="{{data.zoomLink}}"
            (click)="global.gAEvents('pro-perks','onboarding session','','')" class="btn redeem-button">Join Now</a>
          <button *ngIf="user.isProMember !== 1"
            (click)="handleUserClick('masterclass'); global.gAEvents('pro-perks','redeem now','',coupon.companyName)"
            class="btn redeem-button">Join Now</button>



        </div>
      </div>
      <div *ngIf="!global.isMobile()"
        class="col-md-6 text-align-center d-flex justify-content-center align-items-center" style="position:relative;">
        <img src="../../../assets/image/masterclass/newSectionLaptop.svg" alt="Laptop Image"
          style="position:absolute; top:-10px;" class="img-fluid">
      </div>
    </div>
  </div>



  <div class="second-section ps">
    <h2 class="section-title">Pro Sessions</h2>
    <p class="text-muted section-content">
      Join our bi-weekly Pro Sessions—live virtual meetups with the Songdew Team, designed to help you unlock all the
      benefits of your Pro Plan and grow your music career.
    </p>
    <div class="row g-4 master-classes">
      <div class="col-lg-4 col-md-6 col-sm-6 mb-4" *ngFor="let class of data.masterClasses">
        <div class="card master-card h-100" [class.ended]="class.ended">
          <div class="card-image">
            <img [src]="class.image" alt="{{ class.title }}" class="card-img-top" />
            <span *ngIf="!class.ended" class="badge badge-success">{{ class.startingSoonTime }}</span>
          </div>
          <div class="card-body">
            <h3 class="card-title">{{ class.title }}</h3>
            <p class="card-text description">{{ class.description }}</p>
            <div *ngIf="!class.startingSoon" class="details mt-4">
              <p class="mb-2">
                <i class="fa fa-calendar-o mr-2"></i>{{ class.date }}
              </p>
              <p>
                <i class="fa fa-clock-o mr-2"></i>{{ class.duration }}
              </p>
            </div>
            <div *ngIf="!class.ended" class="join-link mt-3">
              <a *ngIf="user.isProMember == 1" href="{{ class.whatsappGroupLink }}"
                (click)="global.gAEvents('pro-perks','join whatsapp group','','masterclass hive')" target="_blank"
                class="btn btn-link join-now pl-0">
                Join Whatsapp Group <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
              <a *ngIf="user.isProMember !== 1"
                (click)="handleUserClick('masterclass'); global.gAEvents('pro-perks','join whatsapp group','','masterclass hive')"
                class="btn btn-link join-now pl-0">
                Join Whatsapp Group <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
            <p *ngIf="class.ended" class="ended-text text-muted mt-3">Class Ended</p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="third-section ps">
    <h2 class="section-title">Exclusive Coupon Codes</h2>
    <p class="text-muted section-content">
      Get special discounts on premium tools and services to enhance your music production workflow.
    </p>
    <div class="row g-4 coupon-codes">
      <div class="col-lg-4 col-md-12 col-sm-6 mb-4" *ngFor="let coupon of data.couponCodes; index as ind">
        <div class="card shadow-sm coupon-card">
          <div class="card-body">
            <div class="d-flex align-items-center coupon-header">

              <img [src]="coupon.brandImage" class="coupon-logo" alt="">
              <span *ngIf="coupon.isNew" class="new-badge">{{ coupon.title }}</span>
              <div>
                <h3 class="coupon-title">{{ coupon.companyName }}</h3>
                <!-- <p class="coupon-companyName">{{ coupon.companyName }}</p> -->
              </div>
            </div>
            <p class="coupon-subtitle mb-4">{{ coupon.subtitle }}</p>
            <hr class="hline">
            <div class="d-flex align-items-center pt-4 mb-3">
              <span class="mr-2" style="color: #222222BF">Coupon:</span>
              <span class="coupon-code ms-2"> {{ user.isProMember == 1 ? coupon.code : maskCouponCode(coupon.code) }}
                <button *ngIf="!codeCopied[ind]" class="copy-btn" [disabled]="user.isProMember != 1"
                  (click)="copyCode(coupon.code,ind)">
                  <i class="fa fa-clone" aria-hidden="true"></i>
                </button>
                <i *ngIf="codeCopied[ind]" class="py-1 px-1 fa fa-check-circle-o" aria-hidden="true"></i>

              </span>

            </div>
            <ul class="list-unstyled coupon-details">
              <li *ngFor="let detail of coupon.details">{{ detail }}</li>
            </ul>
            <!-- <p class="coupon-valid">  <i class="fa fa-calendar-o mr-2"></i> Valid until {{ coupon.validUntil }}</p> -->
            <div style="display: flex; justify-content: center;">
              <button *ngIf="user.isProMember == 1"
                (click)="navigateTo('redeemNow', coupon.redeemNowLink); global.gAEvents('pro-perks','redeem now','',coupon.companyName)"
                class="btn redeem-button">Redeem Now</button>

            </div>
            <div style="display: flex; justify-content: center;">
              <button *ngIf="user.isProMember !== 1"
                (click)="handleUserClick('masterclass'); global.gAEvents('pro-perks','redeem now','',coupon.companyName)"
                class="btn redeem-button">Redeem Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="fourth-section ps">
    <h2 class="section-title">Learning Resources</h2>
    <p class="text-muted section-content">Access exclusive tutorials, guides, and resources to accelerate your music
      production journey.</p>
    <div class="row g-4 learning-resources">
      <div class="col-md-4 mb-4 col-sm-6" *ngFor="let resource of data.learningResources">
        <div class="card resource-card h-100">
          <img [src]="resource.image" alt="{{ resource.title }}" class="card-img-top" />
          <div class="card-body">
            <h3 class="card-title">{{ resource.title }}</h3>
            <p class="card-text description">{{ resource.description }}</p>
            <a *ngIf="user.isProMember == 1" href="{{ resource.link }}"
              (click)="global.gAEvents('pro-perks','learning-resources','',resource.title)"
              download="{{ resource.pdfName }}" class="btn btn-link access-link pl-0">
              Access Resource <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
            <a *ngIf="user.isProMember !== 1"
              (click)="handleUserClick('masterclass');global.gAEvents('pro-perks','learning-resources','',resource.title)"
              class="btn btn-link access-link pl-0">
              Access Resource <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ps">
    <sd-footer></sd-footer>
  </div>

</div>
